<template>
  <div>
    <b-row>
      <h2>
        {{ $t("checklist.sidebar.Create") + " " + $t("sidebar.costCenter") }}
      </h2>
    </b-row>

    <success-fade-alert ref="alertSuccess" :msg="alert.success" />
    <fade-alert-danger ref="alertDanger" :msg="alert.error" />

    <b-row>
      <b-button @click="voltar()" size="sm">
        {{ $t("geral.back") }}
      </b-button>
    </b-row>

    <div style="margin-top: 10px">
      <b-row>
        <b-col lg="6" md="6" sm="6">
          <cost-center :model.sync="model" :modelstate="modelstate" />
        </b-col>
      </b-row>
    </div>

    <b-row style="margin-top: 40px">
      <b-button @click="save" size="sm">
        {{ $t("geral.save") }}
      </b-button>
    </b-row>
  </div>
</template>

<script>
export default {
  components: {
    CostCenter: () =>
      import("@/components_rms/System/CostCenter/costCenter.vue"),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  data() {
    return {
      modelstate: [],
      costCenterId: null,
      alert: {
        error: "Erro ao criar registro: ",
        success: "Registro criado com sucesso",
      },
      model: {
        code: null,
        name: null,
        parentCostCenterId: null,
      },
    };
  },
  methods: {
    save() {
      this.modelstate = [];
      let obj = {
        code: this.model.code,
        name: this.model.name,
        parentCostCenterId: this.model.parentCostCenterId,
      };
      this.$apiScheduler
        .post("/costCenter/create/", obj)
        .then((response) => {
          if (response.data.status == 500) {
            this.alert.error = response.data.title;
            this.$refs.alertDanger.show();
          } else {
            this.$refs.alertSuccess.show();
          }
          this.clearFields();
        })
        .catch((error) => {
          if (error.response.data.errorCode === 400) {
            this.alert.error = error.response.data.errorMessage;
            this.$refs.alertDanger.show();
          }
          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
    clearFields() {
      this.model = {
        code: null,
        name: null,
        parentCostCenterId: null,
      };
    },
    voltar() {
      this.$router.go(-1);
    },
  },
};
</script>